<template>
  <v-layout class="d-flex" row wrap justify-space-around>
    <v-card class="ProblemsDashboard scrollbar">
      <!-- <router-link to="/profile/notifications">
            </router-link> -->
      <h3 class="text-center py-2 white--text red lighten-1">
        <!-- @click="openNotifications" -->
        <v-layout row wrap justify-space-between>
          <v-flex xs2>
            <Icon icon="alert" color="white" />
          </v-flex>
          <v-flex xs8>
            {{ content.header }}
          </v-flex>
          <v-flex xs2 />
        </v-layout>
      </h3>
      <v-layout row wrap v-if="loading">
        <v-flex xs12 class="list-item text-xs-center pa-0">
          <v-progress-linear
            :indeterminate="true"
            class="my-0"
          ></v-progress-linear>
        </v-flex>
      </v-layout>
      <v-layout
        column
        class="notifications-list"
        ref="notifications"
        v-if="!loading"
      >
        <v-row justify="center">
          <v-expansion-panels accordion>
            <v-expansion-panel v-for="(item, i) in notifications" :key="i">
              <!-- <v-badge
                :color="
                  item[0].alert == 'Offline'
                    ? 'grey'
                    : item[0].alert == 'Exceeds'
                    ? 'red'
                    : item[0].alert == 'Low battery'
                    ? 'orange'
                    : item[0].alert == 'Malfunctioned'
                    ? 'red'
                    : 'grey'
                "
                bordered
                inline
              ></v-badge> -->
              <!-- class="expansionP scrollbar" -->
              <v-expansion-panel-header class="flex" v-if="item.length > 0">
                <div
                  class="alertDot"
                  :style="{
                    backgroundColor:
                      item[0] && item[0].alert == 'Offline'
                        ? '#78909C'
                        : item[0] && item[0].alert == 'Exceeds'
                        ? 'red'
                        : item[0] && item[0].alert == 'Low battery'
                        ? '#FFB300'
                        : item[0] && item[0].alert == 'Malfunctioned'
                        ? '#D84315'
                        : '#78909C',
                  }"
                ></div>
                <div class="ms-4">
                  {{ content[i] }} <small> ({{ item.length }}) </small>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-flex
                  xs12
                  v-for="(not, index) in item"
                  :key="index"
                  class="notification-row pt-2 px-2"
                >
                  <v-layout column justify-center wrap class="pointer">
                    <v-flex xs12 md8 class="text-subtitle-2">
                      <div v-if="not.msg_body">
                        <!-- {{ "-" + not.msg_body[locale] + " " + "-" }} -->
                        <strong>
                          {{ not.name ? not.name : not.identifier }}
                        </strong>
                      </div>
                      <span>{{ not.msg_body[locale] }}</span>
                      <span v-if="not.received"> {{ not.received }}</span>
                      <span v-if="not.alert == 'Exceeds'">
                        {{
                          not.type != "hall"
                            ? not.value
                            : $t(not.value == 0 ? "close" : "open")
                        }}</span
                      >
                      <hr class="notBorder" v-if="index < item.length - 1" />
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-row>
        <!-- <v-flex
          xs12
          v-for="(not, index) in mappedNotifications"
          :key="index"
          class="notification-row pt-2 px-2"
        >
          <v-layout column justify-center wrap class="pointer">
            <v-flex xs12 md8 class="text-subtitle-2">
              <strong v-if="not.msg_body">
                <v-badge
                  :color="
                    not.alert == 'Offline'
                      ? 'grey'
                      : not.alert == 'Exceeds'
                      ? 'red'
                      : not.alert == 'Low battery'
                      ? 'orange'
                      : not.alert == 'Malfunctioned'
                      ? 'red'
                      : 'grey'
                  "
                  bordered
                  inline
                ></v-badge>
                {{ not.msg_body[locale] + " " + "-" }}
                {{ not.name ? not.name : not.identifier }}
              </strong>
              
            </v-flex>
          </v-layout>
        </v-flex> -->
        <v-flex
          xs12
          class="list-item text-center pa-3"
          v-if="notifications && notifications.length == 0"
        >
          <strong class="text-xs-center">{{ content.nonew }}</strong>
        </v-flex>
      </v-layout>
    </v-card>
  </v-layout>
</template>
<script>
import Lang from "@/helpers/lang";
export default {
  name: "ProblemsCard",
  props: {
    notifications: {
      type: Object,
      default: null,
    },
    // device: {
    //   type: Object,
    //   default: null,
    // },
    // gateway: {
    //   type: Object,
    //   default: null,
    // },
    // battery: {
    //   type: Object,
    //   default: null,
    // },
  },
  data() {
    return {
      locale: Lang.get(),
      content: {},
      loading: false,
    };
  },
  mounted() {
    // console.log("Object.values(this.notifications)", this.notifications);
    this.setLang();
  },
  watch: {
    // homePage: {
    //   handler() {
    //     console.log(this.homePage);
    //   },
    //   deep: true,
    // },
  },
  computed: {
    mappedNotifications() {
      // console.log("Object.values(this.notifications)", this.notifications);
      return Object.values(this.notifications);
    },
    // notifications() {
    //   return [
    //     {
    //       type: "device",
    //       alert: "Offline",
    //       msg_body: "Device is Offline",
    //       created_at: new Date().toLocaleTimeString(),
    //     },
    //     {
    //       type: "device",
    //       alert: "Exceeds",
    //       msg_body: "Device is exceeding account",
    //       created_at: new Date().toLocaleTimeString(),
    //     },
    //     {
    //       type: "battery",
    //       alert: "Low battery",
    //       msg_body: "Low battery detected",
    //       created_at: new Date().toLocaleTimeString(),
    //     },
    //     {
    //       type: "gateway",
    //       alert: "Offline",
    //       msg_body: "gateway is Offline",
    //       created_at: new Date().toLocaleTimeString(),
    //     },
    //     {
    //       type: "device",
    //       alert: "Malfunctioned",
    //       msg_body: "Device is Malfunctioned!",
    //       created_at: new Date().toLocaleTimeString(),
    //     },
    //   ];
    // },
    // hasGroups() {
    //   return this.$store.getters["groups/hasGroups"];
    // },
    // homePage: {
    //   get() {
    //     let home = localStorage.getItem("homePage");
    //     if (home == "mainDash") {
    //       return null;
    //     } else {
    //       return home;
    //     }
    //     // return localStorage.getItem("homePage");
    //   },
    //   set(home) {
    //     if (home) {
    //       if (home == "groups" && !this.hasGroups) {
    //         this.$router.push("/groups/edit");
    //       } else {
    //         let path = null;
    //         if (home == "mainDash") {
    //           path = "/";
    //           this.$router.push(path);
    //           localStorage.setItem("homePage", home);
    //         } else {
    //           path = "/" + home;
    //           this.$router.push(path);
    //           localStorage.setItem("homePage", home);
    //         }
    //       }
    //       localStorage.setItem("homePage", home);
    //       // console.log("home from storage", localStorage.getItem("homePage"));
    //     }
    //   },
    // },
  },
  methods: {
    setLang() {
      if (this.locale == "en") {
        this.content = {
          offlineGates: "Offline gateways",
          offlineDevs: "Offline devices",
          exceeds: "Exceeds value devices",
          malfunctioned: "Malfunctioned devices",
          low: "Low battery",
          header: "Existing Issues",
          countdevices: "Number of devices",
          editview: "edit view",
          addDevices: "add switches",
          editGroup: "edit group",

          empty: {
            group: "The group don't have registered switches yet!",
            title: "You don't have any switches registered yet!",
            subtitle: "Click here to register a new switch",
            btn: "Register A New Switch",
            empty: "The group is empty!",
            sectitle: "All of our devices are hidden",
            clickto: "Click here to ",
          },
          notifications: "Notifications",
          lastNotifications: "Last Notifications",
          scrolldown: "scroll down",
          nonew: "no new notifications",
          type: {
            NotConnected: "Lost power or internet connection",
            IsConnected: "The power or internet connection is back",
            NoSensor: "The sensor has disconnected",
            ForbiddenArea: "Is in a forbidden area",
            MetTreshold: "Reached the threshold you set",
            FixedMetTreshold: "The indicators returned to normal",
            FloodSuspected: "The buoy identifies flooding",
            FloodFixed: "The buoy is back to normal",
            DoorOpened: "The sensor detected a door opening",
            DoorClosed: "The sensor detected a door closing",
            SmokeAlarm: "Warning of smoke!",
            MotionDetected: "Detects motion!",
            LowBattery: "The device has low battery",
          },
        };
      } else if (this.locale == "he") {
        this.content = {
          offlineGates: "מרכזיות מנותקות",
          offlineDevs: "מכשירים מנותקים",
          exceeds: "מכשירים חורגים מהסף המוגדר",
          malfunctioned: "מכשירים תקולים",
          low: "סוללה נמוכה",
          header: "בעיות קיימות",
          countdevices: "מספר מכשירים",
          editview: "עריכת תצוגה",
          addDevices: "הוספת מכשירים",
          editGroup: "עריכת קבוצה",

          empty: {
            group: "עדיין לא נוספו מכשירים לקבוצה!",
            title: "עדיין לא רשומים אצלך מכשירים!",
            subtitle: "לחץ כאן כדי לרשום מכשיר חדש",
            btn: "הוספת מכשיר חדש",
            empty: "קבוצה זו עדיין ריקה",
            sectitle: "כל המכשירים הרשומים אצלך מוסתרים.",
            clickto: "לחץ כאן ל",
          },
          notifications: "התראות",
          lastNotifications: "התראות אחרונות",
          scrolldown: "גלול למטה",
          nonew: "אין התראות חדשות",
          type: {
            NotConnected: "איבד חיבור לחשמל או לאינטרנט",
            IsConnected: "חזר החיבור לחשמל או לאינטרנט",
            NoSensor: "החיישן לא מחובר",
            ForbiddenArea: "נמצא באזור אסור",
            MetTreshold: "הגיע לסף שהגדרת",
            FixedMetTreshold: "המדדים חזרו למצב תקין",
            FloodSuspected: "המצוף מזהה הצפה",
            FloodFixed: "המצוף חזר למצב תקין",
            DoorOpened: "החיישן מזהה פתיחה של דלת",
            DoorClosed: "החיישן מזהה סגירה של דלת",
            SmokeAlarm: "אזהרת עשן!",
            MotionDetected: "מזהה תנועה!",
            LowBattery: "למכשיר יש סוללה חלשה",
          },
        };
      }
    },
    changeRoute(path) {
      // console.log(this.$router);
      if (this.$router.history.current.path != path) {
        this.$router.push(path);
      }
    },
    openNotifications() {
      console.log(this.$router);
      //   if (this.$router.history.current.path != path) {
      //     this.$router.push(path);
      //   }
    },
  },
};
</script>
<style scoped lang="scss">
hr {
  border-color: rgba(0, 0, 0, 0.1) !important;
}

.ProblemsDashboard {
  width: 70vw;
  max-height: 437px;
  overflow-y: auto;
}
.alertDot {
  max-width: 12px;
  width: 12px;
  max-height: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: #f44336;
  // position: absolute;
  // right: 10px;
  margin-inline-end: 4px;
  // top: 10px;
}
// .expansionP {
//   // width: 70vw;
//   max-height: 437px;
//   overflow-y: scroll;
// }
.scrollbar::-webkit-scrollbar:horizontal {
  width: 0px;
}
.alertChip {
  height: 24px;
  //   margin-bottom: 2px;
}
.switchBar {
  min-height: 50px;
  /* border-radius: 5px; */
}

.itemTitle {
  font-size: 11pt;
}

.pt-0 {
  margin-top: -5px;
}

.dryContact {
  max-height: 20px;
  /* max-width: 30px; */
  width: auto;
}

.maxWidthWithBtns {
  max-width: calc(100vw - 165px);
}
.itemBtns .minWidth160 {
  min-width: 120px;
}

.layout.itemBtns.row.wrap.justify-end.align-center.shrink {
  font-size: 13pt;
}

@media screen and (max-width: 600px) {
  .ProblemsDashboard {
    width: 90vw;
    max-height: unset;
    overflow-y: unset;
  }
  #devices-xs {
    margin-top: 15px;
    height: fit-content;
  }
  .itemTitle,
  .limitWidth {
    width: 100%;
    /* max-width: calc(100vw - 186px); */
  }
  #devicesMain {
    /* min-height: calc(96vh - (48px + 56px)); */
    height: fit-content;
  }
}
@media screen and (min-width: 600px) {
  #devices {
    padding: 0 15px;
  }
  /* #devices,
  #device {
    overflow-y: auto;
    max-height: calc(100vh - 195px);
  } */
  #devices::-webkit-scrollbar,
  #device::-webkit-scrollbar {
    scrollbar-width: 0px;
    width: 1em;
    display: none;
  }
}
@media screen and (min-width: 960px) {
  .d-r,
  .divide-l {
    padding-left: 15px;
  }
  .d-l,
  .divide-r {
    padding-right: 15px;
  }
  .divide-l {
    border-left: 2px solid #e9e9e9;
  }
  .divide-r {
    border-right: 2px solid #e9e9e9;
  }
}

.notdevicesbtn {
  font-size: 14pt;
}
// .v-btn-toggle--group {
//   border: unset;
// }

// }
</style>
